export default __webpack_public_path__ + "static/media/icon-arrow-down.5b0512cf.svg";